import { Injectable } from "@angular/core";
import {
  UrlTree,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot} from "@angular/router";
import { map, Observable, take, timeout, catchError, of } from "rxjs";
import { AccountState } from "../account/state/account.state";
import { Select } from "@ngxs/store";
import { datadogRum } from "@datadog/browser-rum";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"})
export class AuthGuard {
  @Select(AccountState.account) account$!: Observable<any>;

  constructor(private router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.account$.pipe(
      take(1),
      timeout(5000),
      map((account) => {
        const sessionToken = sessionStorage.getItem("accessToken");
        const localToken = localStorage.getItem("accessToken");
        const hasToken = !!(sessionToken || localToken);

        if (!hasToken) {
          return this.router.createUrlTree(["/auth/login"]);
        }

        if (hasToken && account) {
          if (environment.stage === "prod") {
            datadogRum.setUser({
              id: account.id,
              name: account.name,
              email: account.email});
            (window as any)?.DD_RUM.startSessionReplayRecording();
          }
          return true;
        }

        if (hasToken && !account) {
          return true;
        }

        return this.router.createUrlTree(["/auth/login"]);
      }),
      catchError((error) => {
        console.error("Erro no AuthGuard:", error);
        const sessionToken = sessionStorage.getItem("accessToken");
        const localToken = localStorage.getItem("accessToken");
        const hasToken = !!(sessionToken || localToken);

        if (hasToken) {
          return of(true);
        }
        return of(this.router.createUrlTree(["/auth/login"]));
      }),
    );
  }

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    const sessionToken = sessionStorage.getItem("accessToken");
    const localToken = localStorage.getItem("accessToken");
    const hasToken = !!(sessionToken || localToken);

    if (hasToken) {
      return true;
    }

    this.router.navigate(["/home"]);
    return false;
  }
}
